import { EPAPERIMAGE_ARE_LOADING, EPAPERIMAGE_FETCH_DATA_SUCCESS, EPAPERIMAGE_HAVE_ERROR } from '../actionType.js';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function ePaperImageAction(action, payload) {
    switch (action) {
        case EPAPERIMAGE_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };

        case EPAPERIMAGE_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };

        case EPAPERIMAGE_FETCH_DATA_SUCCESS:
            return {
                type: action,
                ePaperImage: payload,
            };

        default:
            return;
    }
}

export function ePaperImageFetchData() {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(ePaperImageAction(EPAPERIMAGE_ARE_LOADING, true));
                Get(HttpService.ePaperImage).then((result) => {
                    dispatch(ePaperImageAction(EPAPERIMAGE_FETCH_DATA_SUCCESS, result.data));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(ePaperImageAction(EPAPERIMAGE_HAVE_ERROR, true));
        }
    }
}


